// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__1Ngjt","upload":"Small_upload__nbvWU","imageWrap":"Small_imageWrap__3ULVe","removeBtn":"Small_removeBtn__3ENIO"};